import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [devToken, setDevToken] = useState(null);

    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setSent(true);
            if (data.dev_token) setDevToken(data.dev_token);
        } catch (e) {
            toast.error(formatErr(e.response?.data?.detail));
        } finally {
            setBusy(false);
        }
    }

    return (
        <>
            <Navbar />
            <section className="pt-32 pb-24 bg-cream min-h-[80vh]">
                <div className="container-edge max-w-md mx-auto">
                    <span className="label-overline text-wine">Conta</span>
                    <h1 className="mt-4 font-heading text-5xl text-wine-dark">Esqueceu-se?</h1>
                    <p className="mt-4 text-wine-dark/70">
                        Indique o seu email. Enviaremos um link para repor a sua palavra-passe.
                    </p>

                    {!sent ? (
                        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="forgot-form">
                            <label className="block">
                                <span className="label-overline text-wine-dark">Email</span>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="mt-2 w-full bg-transparent border border-wine-dark/20 rounded-md px-4 py-3 text-sm focus:border-wine"
                                    data-testid="forgot-email"
                                />
                            </label>
                            <button disabled={busy} className="btn-wine w-full" data-testid="forgot-submit">
                                {busy ? "A enviar…" : "Enviar link"}
                            </button>
                        </form>
                    ) : (
                        <div className="mt-10 bg-white border border-gold-soft/30 rounded-md p-6 shadow-sm">
                            <Mail className="h-10 w-10 text-vineyard" strokeWidth={1.5} />
                            <h2 className="mt-4 font-heading text-2xl text-wine-dark">Verifique o seu email</h2>
                            <p className="mt-2 text-sm text-wine-dark/70">
                                Se houver uma conta associada a <strong>{email}</strong>, receberá um link
                                para repor a palavra-passe.
                            </p>
                            {devToken && (
                                <div className="mt-4 bg-cream-warm border border-gold-soft/40 rounded p-3">
                                    <p className="text-xs text-wine-dark/70 mb-2">Modo demo · Link direto:</p>
                                    <Link
                                        to={`/reset-password?token=${devToken}`}
                                        className="text-xs text-wine font-semibold inline-flex items-center gap-2 hover:text-gold-deep"
                                        data-testid="dev-reset-link"
                                    >
                                        Repor agora <ArrowRight className="h-3 w-3" />
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="mt-8 text-sm text-wine-dark/70">
                        <Link to="/login" className="text-wine font-semibold hover:text-gold-deep">
                            ← Voltar a entrar
                        </Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
